import { FC, useEffect, useRef } from "react";

import { useLocales } from "@lib/custom-locales";
import { useRouter } from "@lib/router";

import createBot from "./utils/createBot";

const Webchat: FC = () => {
  const botNodeRef = useRef(null);

  const { defaultLocale } = useRouter();

  const state = useLocales();

  useEffect(() => {
    if (botNodeRef.current && defaultLocale && state?.customLocale) {
      createBot(botNodeRef.current, defaultLocale, state?.customLocale || "");
    }
  }, [defaultLocale, state?.customLocale]);

  return <div ref={botNodeRef} key={`webchat-bot-${defaultLocale}`} />;
};
export default Webchat;
